import { ColoreEvento } from 'app/model/colore_evento';
import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';

export interface CSSModel {
	[className: string]: CSSStyleDeclaration;
}

@Component({
	selector: 'app-style',
	template: '',
	styleUrls: [ ]
})
// TODO: Questo componente è application-specific. Sarebbe da fare meglio perché può 
// essere utile...
export class StyleComponent implements  OnDestroy {

	public static sanitize(name: string) {
		return (name||"").toLowerCase().replace(/\ /g, '-');
	}

	private style: CSSStyleSheet;
	private mapper: { [name:string]: CSSStyleRule } = { };
	private subscriptions: Subscription;

	constructor(colors: ImpostazioniGenerali) {
		this.style = $("<style>").appendTo("head").prop("sheet");

		this.subscriptions = colors.pipe(
			switchMap(
				categorie => Observable.combineLatest(...categorie)
			),
			switchMap(
				categoria => Observable.combineLatest(...([] as ColoreEvento[]).concat(...categoria))
			)
		).subscribe(
			colori => {
				for(let colore of colori) {
					var rule: CSSStyleRule;
					if(colore.nome in this.mapper) {
						rule = this.mapper[colore.nome];
					} else {
						// Devo rendere la stringa compatibile...
						let styleName = StyleComponent.sanitize(colore.nome);
						let i = this.style.insertRule(`.${styleName} {}`, this.style.cssRules.length);
						rule = this.mapper[colore.nome] = this.style.cssRules.item(i) as CSSStyleRule;
					}

					rule.style.background = colore.colore;
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/style/style.component.ts